import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ApiClient from '../utils/apiClient';

/**
 * Komponente, die alle aktiven API-Anfragen abbricht, wenn sich die Route ändert
 */
function ApiRequestCleaner() {
  const location = useLocation();

  useEffect(() => {
    // Beim Routenwechsel alle aktiven API-Anfragen abbrechen
    return () => {
      console.log('Route changed, aborting all API requests');
      ApiClient.abortAll();
    };
  }, [location.pathname]);

  // Diese Komponente rendert nichts
  return null;
}

export default ApiRequestCleaner;
